import React from 'react';
import { Tooltip, Typography } from 'antd';
import { VipCustomerDto, VipCustomerTicketDto } from '../../types';

type VipCustomerProps = {
  content?: string | null;
  customer?: VipCustomerTicketDto | VipCustomerDto | null;
  fontSize?: string;
};

const VipCustomer: React.FC<VipCustomerProps> = ({ content, customer, fontSize }) => {
  if (!customer) {
    return (
      <Tooltip title={<div className={'w-124'}>{content}</div>}>
        <Typography.Text className={`text-[${fontSize ? fontSize : '14px'}]/[18px] text-[#4D5664]`}>
          {content || ''}
        </Typography.Text>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      title={
        <div className={'w-max min-w-[20rem] space-y-1.5'}>
          <div className={'flex w-full space-x-2.5'}>
            <div className={'w-[4rem]'}>KH Vip:</div>
            <div>{customer?.vipCustomerId}</div>
          </div>
          <div className={'flex w-full space-x-2.5'}>
            <div className={'w-[4rem]'}>Mã KH:</div>
            <div>{customer?.code}</div>
          </div>
          <div className={'flex w-full space-x-2.5'}>
            <div className={'w-[4rem]'}>SĐT:</div>
            <div>{customer?.phoneNumber}</div>
          </div>
          <div className={'flex w-full space-x-2.5'}>
            <div className={'w-[4rem]'}>Note:</div>
            <div className={'max-w-[20rem]'}> {customer.note}</div>
          </div>
        </div>
      }
      overlayInnerStyle={{
        width: 'fit-content',
        whiteSpace: 'normal'
      }}
    >
      <Typography.Text
        className={`truncate text-[${fontSize ? fontSize : '14px'}]/[20px] cursor-pointer font-semibold`}
        style={{
          color: `${customer?.customerGroup?.color ? `${customer?.customerGroup?.color}` : customer?.color ? customer?.color : '#141414'}`
        }}
      >
        {content}
      </Typography.Text>
    </Tooltip>
  );
};

export default VipCustomer;
